import { render } from "./ButtonAdd.vue?vue&type=template&id=401b72e6&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"

import "./ButtonAdd.vue?vue&type=style&index=0&id=401b72e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401b72e6"],['__file',"src/views/FAQManagement/components/contentComponents/ButtonAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "401b72e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('401b72e6', __exports__)) {
    api.reload('401b72e6', __exports__)
  }
  
  module.hot.accept("./ButtonAdd.vue?vue&type=template&id=401b72e6&scoped=true", () => {
    api.rerender('401b72e6', render)
  })

}


export default __exports__